import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { EdpInputToogleComponent } from "./edp-input-toogle.component";
import { TranslateModule } from "@ngx-translate/core";

@NgModule({
    declarations: [EdpInputToogleComponent],
    imports: [CommonModule, TranslateModule],
    exports: [EdpInputToogleComponent],
})
export class EdpInputToogleModule {}
